export const routes = {
  home: '/',
  chooseServer: '/choose-server',
  recovery: '/recovery',
  notification: '/notification',
  dashboard: '/dashboard',
  features: '/features',
  premium: '/premium',
  changelog: '/changelog',
  success: '/success',
  auth: 'https://discord.com/api/oauth2/authorize?client_id=1142209558903783525&response_type=code&redirect_uri=https%3A%2F%2Fthemis-dashboard.vercel.app%2Fsuccess&scope=identify+email+guilds.members.read+guilds.join+guilds+messages.read',
};

export const includePathsHeaderUser = [routes.chooseServer, routes.notification];
export const includePathsNavigation = [
  routes.home,
  routes.features,
  routes.premium,
  routes.changelog,
];
export const includePathsFooter = [routes.home, routes.features, routes.premium, routes.changelog];
export const includePathsChat = [routes.home, routes.features, routes.premium, routes.changelog];
export const includeLayout = [routes.home, routes.features, routes.premium, routes.changelog];
export const excludeTipForAdaptive = [
  routes.home,
  routes.features,
  routes.premium,
  routes.changelog,
];
